import React from 'react';
import PropTypes from 'prop-types';

import { Input as MUIInput } from '@mui/material';

export const Input = props => <MUIInput {...props} />;

Input.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  endAdornment: PropTypes.node,
  inputProps: PropTypes.object,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  readOnly: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default Input;
